import React from "react";
import ContentButton from "../core/ui/ContentButton";

interface OfferSectionProps {
  id?: string;
  heading: React.ReactNode;
  lead: React.ReactNode;
  footnote: React.ReactNode;
  primaryLabel?: string;
  primaryHref?: string;
}

/**
 * Centered mid-page offer: heading, near-white lead paragraph, one primary CTA, and a
 * dimmed footnote for pricing or terms. Deliberately single-CTA — the closing CtaSection
 * carries the two-button action row.
 */
const OfferSection: React.FC<OfferSectionProps> = ({
  id,
  heading,
  lead,
  footnote,
  primaryLabel = "Book a Demo →",
  primaryHref = "https://calendar.app.google/rQuDdWM57HswfdSB9",
}) => {
  const primaryIsExternal = /^https?:/.test(primaryHref);
  return (
    <section id={id} className="cs-section cs-offer">
      <div className="cs-offer-inner">
        <h2>{heading}</h2>
        <p className="cs-offer-lead">{lead}</p>
        <div className="cs-offer-actions">
          <ContentButton
            href={primaryHref}
            variant="primary"
            size="lg"
            target={primaryIsExternal ? "_blank" : undefined}
            rel={primaryIsExternal ? "noopener noreferrer" : undefined}
          >
            {primaryLabel}
          </ContentButton>
        </div>
        <p className="cs-offer-footnote">{footnote}</p>
      </div>
    </section>
  );
};

export default OfferSection;
